var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("id-dispenser", {
    attrs: { prefix: "settings" },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function(ref) {
            var id = ref.id
            return [
              _c("div", { staticClass: "row mb-2" }, [
                _c(
                  "div",
                  { class: "col-" + _vm.colSize },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("label", { attrs: { for: id } }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.label) +
                              "\n                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._t("extra")
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: "col-" + _vm.contentColSize },
                  [_vm._t("default", null, { id: id })],
                  2
                )
              ])
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }